// extracted by mini-css-extract-plugin
module.exports = {"header":"t_G g_p","logo":"t_H"};